module.exports = __webpack_public_path__ + "img/stripe-logo.fd1d6340.png";